// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const NewsBarContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-newsbarcontainer" */ "./NewsBarContainer")).then((bundle)=>{
        return {
            default: bundle.NewsBarContainer
        };
    });
export const LazyNewsBarContainer = /*#__PURE__*/ lazy(NewsBarContainerLazyLoader);
